import { getPermissionsByRoles } from '@vy/services';
import { ROLES, type Permission } from '@vy/types';
import { isNullOrUndefined, validateEnum } from '@vy/utils';
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useVyNavigate } from '../hooks/use-vy-navigate';
import { ROLE_KEY } from '../services/user-auth/user-auth-consts';
import { getLocalStorageString } from '../utils/local-storage';

type PermissionsProtectedRouteProps = {
  requiredPermissions: Permission[];
};

const PermissionsProtectedRoute: React.FC<PermissionsProtectedRouteProps> = ({ requiredPermissions }) => {
  const role = getLocalStorageString(ROLE_KEY);
  const navigate = useVyNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isNullOrUndefined(role)) {
      navigate('/login');

      return;
    }

    validateEnum(role, ROLES);

    const permissions = getPermissionsByRoles(role);
    const hasPermission = requiredPermissions.some((permission) => permissions.includes(permission));

    if (!hasPermission) {
      navigate('/home', { replace: true });
    }
  }, [role, navigate, requiredPermissions, location.pathname]);

  return <Outlet />;
};

export default PermissionsProtectedRoute;
